import PageSubMenuPill from './PageSubMenuPill';

export default PageSubMenuPill;
